import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { Col, Container, Row } from 'react-bootstrap';
import { AboutFocus } from '../data/AboutFocus';
import styles from './CardWe.module.css';

const CardWe = () => {
    useEffect(() => {
        AOS.init({
            duration: 2000,
            disable: window.innerWidth < 768
        });
    }, []);

    return (
        <div className={styles.fondo}>
            <section className={styles.serviceWrapper} aria-labelledby="sobre-nosotros-titulo">
                <Container>
                    <Row>
                        <Col sm={12}>
                            <div className={`${styles.sectionTitle} text-center`}>
                                <h1 id="sobre-nosotros-titulo">Sobre Nosotros</h1>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        {AboutFocus.map(({ id, title, description, img, isList }) => (
                            <Col
                                key={id}
                                xs={12}
                                md={12}
                                lg={4}
                                className="d-flex justify-content-center"
                            >
                                <article
                                    className={styles.singleServiceBox}
                                    data-aos="flip-left"
                                    role="region"
                                    aria-label={`Servicio: ${title}`}
                                >
                                    <div className={styles.serviceIcon}>
                                        <img
                                            src={img}
                                            alt={`Imagen ilustrativa del servicio ${title}`}
                                            loading="lazy"
                                        />
                                    </div>
                                    <h2 className={styles.serviceTitle}>{title}</h2>
                                    {isList ? (
                                        <ul className={styles.doctorList}>
                                            {description.map((doc, index) => (
                                                <li key={index}>
                                                    <strong>{doc.nombre}</strong> - C.O.P. {doc.cop}
                                                </li>
                                            ))}
                                        </ul>
                                    ) : (
                                        <p>{description}</p>
                                    )}
                                </article>
                            </Col>
                        ))}
                    </Row>
                </Container>
            </section>
        </div>
    );
};

export default CardWe;
